export const TABLE_DATE_FORMAT = 'iii MMM do yyyy h:mm:ss a';
export const TOOLTIP_DATE_FORMAT = 'yyyy-MM-dd h:mm:ss a';
export const AXIS_TICK_COUNT = 9;
export const AXIS_TICK_STYLE = { fontSize: 12, fontFamily: 'Century Gothic' };

export interface CreativeInfo {
  avail: string;
  cost: number;
  creative: string;
  kpi: number;
  length: number;
  network: string;
  networkName: string;
  program: string;
  time: string;
  timeslot: number;
  xPercentage?: number;
  yPercentage?: number;
  overrideImage?: boolean;
}

export interface SpikeChartData {
  time: number;
  formattedTime: string;
  kpiCount: number;
  dotValue: number;
  creativeInfo: CreativeInfo[];
}

// Stable reference so passing "no data yet" doesn't fabricate a new array every render.
export const EMPTY_SPIKE_CHART_DATA: SpikeChartData[] = [];

export interface SpotTableRow extends CreativeInfo {
  odd: boolean;
}

export interface SpotCoordinate {
  x: number;
  y: number;
}

export interface ChartMargin {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface ChartGrid {
  vertical: boolean;
  stroke: string;
  strokeWidth: number;
}

// No design-token equivalent for this specific dot-border tint.
export const DOT_BORDER = '#D4BDF2';
